//export const API_URL = "http://localhost";
export const API_URL = window.__env && window.__env.api.url ? window.__env.api.url : 'https://api.soloweb.io';
export default API_URL;
export const DEBUGENABLED = window.__env ? window.__env.debug : true;
export const FEATURE_DRAFT_ENABLED = true;
